<template>
  <div>
    <the-nav-bar :title="$t('newSettings.kycAdv.title')"  ref="nav"/>
      <!-- load success -->
    <div class="success-wrapper">
      <!-- 正在审核 -->
      <div class="status-wrapper col-center" v-if="status === 'applied'">
        <img src="@/images/status-waiting.svg" alt="Wait" class="icon" />
        <span class="text">
          {{ $t('newSettings.apply.wait') }}
        </span>
        <span class="subtext">
          {{ $t('newSettings.apply.waitInfo') }}
        </span>
        <md-button type="primary" @click="goBack">
          <span>{{ $t('common.back') }}</span>
        </md-button>
      </div>
      <!-- 审核成功 -->
      <div class="status-wrapper col-center" v-else-if="status === 'adopted'">
        <img src="@/images/status-success.svg" alt="Success" class="icon" />
        <span class="text">
          {{ $t('newSettings.apply.adopted') }}
        </span>
        <span class="subtext">
           {{ $t('newSettings.apply.adoptedInfo') }}
        </span>
        <md-button type="primary" @click="goBack">
          <span>{{ $t('common.back') }}</span>
        </md-button>
      </div>
      <!-- 未通过 -->
      <div class="status-wrapper col-center" v-else-if="status === 'fail'">
        <img src="@/images/status-failed.svg" alt="Failed" class="icon" />
                <span class="text">
          {{ $t('newSettings.apply.fail') }}
        </span>
        <span class="subtext">
        {{ $t('newSettings.apply.failInfo') }}  {{ message }}
        </span>
        <md-button type="primary" @click="goKyc">
          <span>{{ $t('common.reapply') }}</span>
        </md-button>
      </div>

       <!-- 禁止 -->
       <div class="status-wrapper col-center" v-else-if="status === 'fobidden'">
        <img src="@/images/status-failed.svg" alt="Failed" class="icon" />
                <span class="text">
          {{ $t('newSettings.apply.forbidden') }}
        </span>
        <span class="subtext">
        {{ $t('newSettings.apply.forbiddenInfo') }}  {{ message }}
        </span>
        
      </div>

    </div>

    <md-popup  class="inner-popup" v-model="isPopupShow" :mask-closable="true" >
      <md-popup-title-bar
        only-close
        :title="$t('newSettings.kycAdv.title')"
        title-align="left"
        @cancel="hidePopUp()"
      ></md-popup-title-bar>
    <md-field :brief="$t('newSettings.notKeepInfo')" class="body-wrapper">
     <template >
        <md-input-item
          name="trueName"
          type="text"
          v-model.trim="trueName"
          :title="$t('newSettings.trueName')"
          align="right"
          disabled
        ></md-input-item>

        <md-field-item :title="$t('newSettings.kycAdv.photosInfo')" class="upload photos-class" >
          <div  slot="children" class="">
              <ul class="image-reader-list">
                  <li
                    class="image-reader-item"
                    v-for="(img, index) in photos"
                    :key="index"
                    :style="{
                      'backgroundImage': `url(${img})`,
                      'backgroundPosition': 'center center',
                      'backgroundRepeat': 'no-repeat',
                      'backgroundSize': 'cover'
                    }">
                    <md-tag
                      class="image-reader-item-del"
                      size="small"
                      shape="quarter"
                      fill-color="#111A34"
                      type="fill"
                      font-color="#fff"
                      @click.native="onDeleteImage(index)"
                    >
                      <md-icon name="close"></md-icon>
                    </md-tag>
                  </li>
                  <li class="image-reader-item add">
                    <md-image-reader
                      @select="onReaderSelect"
                      @complete="onReaderComplete"
                      @error="onReaderError"
                      size="8192"
                      is-multiple
                    ></md-image-reader>
                    <md-icon name="camera" size="md" color="#CCC"></md-icon>
                    <p>{{ $t('newSettings.upload') }}</p>
                  </li>
                </ul>
          </div>
         </md-field-item>
         
      </template>

      <div class="field-footer" slot="footer">
        <div class="info" style="color:red;">
          {{ $t('newSettings.kycAdv.uploadTips') }}
        </div>
        <div class="btn-wrapper">
          <md-button
            :type="btnDisabled ? 'disabled' : 'primary'"
            @click="onSubmit"
          >
            <md-activity-indicator
              v-if="isSubmitting"
              type="carousel"
              color="currentColor"
            ></md-activity-indicator>
            <span v-else>{{ $t('common.submit') }}</span>
          </md-button>
        </div>
      </div>
    </md-field>

    </md-popup>

  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import {
  Popup,
  PopupTitleBar,
  Field,
  FieldItem,
  InputItem,
  Button,
  ImageReader,
  Icon,
  Tag,
  Toast,
  ActivityIndicator,
  Dialog,
} from 'mand-mobile';
import imageProcessor from 'mand-mobile/components/image-reader/image-processor';
import postUserAdvKyc from '@/api/post-user-kyc-adv';
import getUserAdcKyc from '@/api/get-user-kyc-adv';
export default {
  components: {
    TheNavBar,
    [Popup.name]: Popup,
    [PopupTitleBar.name]: PopupTitleBar,
    [Field.name]: Field,
    [FieldItem.name]: FieldItem,
    [InputItem.name]: InputItem,
    [Button.name]: Button,
    [ImageReader.name]: ImageReader,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [ActivityIndicator.name]: ActivityIndicator,
  },
  data() {
    return {
      isPopupShow: false,
      trueName: '',
      status: '',
      photos: [],
      idcardFront:'',
      isSubmitting: false,
      isRemoving: false,
      btnDisabled: false,
      validate: false,
    };
  },
  computed: {

  },
  created(){
    getUserAdcKyc().then(data => 
    {
      const d = data.data;
      this.trueName = d.trueName;
      this.status = d.status;
      this.message = d.message;
      if(this.status ==='no'){
        this.isPopupShow = true;
      }
    }).catch(err => {
      Dialog.alert({
        icon: 'fail',
        title: this.$t('error.occurs'),
        content: err.message,
        confirmText: this.$t('common.confirm'),
      });
      this.$router.go(-1);
    });
  },
  mounted() {
    
  },
  methods: {
    hidePopUp() {
      this.goBack();
    },
    goKyc() {
      this.isPopupShow =true;
    },
    goBack() {
      this.$refs.nav && this.$refs.nav.goBack();
    },
    onReaderSelect() {
      Toast.loading('loading...');
    },
    onReaderComplete(name, { dataUrl }) {
      const imageList = this.photos || [];
      if(imageList.length ===6){
        Dialog.alert({
          icon: 'fail',
          title: this.$t('error.occurs'),
          content: this.$t('newSettings.kycAdv.photosLimit'),
          confirmText: this.$t('common.confirm'),
        });
        Toast.hide();
        return;
      }
      imageProcessor({
        dataUrl,
        width: 768,
        quality: 1,
      }).then(({dataUrl}) => {
        dataUrl && imageList.push(dataUrl);
        this.photos = imageList;

        Toast.hide();
      }).catch(err => {
        Toast.failed(err.message);
      }); 
        
    },
    onReaderError(name, {msg}) {
      Toast.failed(msg);
    },
    onDeleteImage(index) {
      const imageList = this.photos || [];
      imageList.splice(index, 1);
      this.photos = imageList;
    },
    onSubmit() {
      if(this.photos.length ==0){
        Dialog.alert({
          icon: 'fail',
          title: this.$t('error.occurs'),
          content: this.$t('newSettings.kycAdv.photosEmptyErr'),
          confirmText: this.$t('common.confirm'),
        });
        return; 
      }
      this.isSubmitting = true;
      let params = {
        trueName: this.trueName,
        photos: this.photos,
      };

      postUserAdvKyc(params)
        .then(data => {
          this.isSubmitting = false;
          const d = data.data;
          this.trueName = d.trueName;
          this.status = d.status;
          this.message = d.message;
          if(this.status ==='no'){
            this.isPopupShow = true;
          }else{
            this.$store.commit('setAdvKycInfo',{
              status:this.status,
              message: this.message,
            });
            this.isPopupShow =false;
          }
          
        })
        .catch(err => {
          this.isSubmitting = false;
          Dialog.alert({
            icon: 'fail',
            title: this.$t('error.occurs'),
            content: err.message,
            confirmText: this.$t('common.confirm'),
          });
        });
    },
    copy(source, target) {
      Object.entries(source).forEach(([key]) => {
        source[key] = target[key];
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .md-popup
    top: 10vh;
.status-wrapper {
  min-height: 80vw;

  .md-icon, .icon {
    font-size: 16vw;
    width: 16vw;
    height: 16vw;
  }

  .text {
    margin-top: 9.6vw;
    font-size: 4.8vw;
  }

  .subtext {
    margin: 2.13vw 9.6vw 0;
    text-align: center;
  }

  .md-button {
    margin-top: 14.4vw;
    width: 60vw;
  }

}

.body-wrapper {
  padding-bottom: 20vw;

  .md-field-item {
    margin-bottom: 3.2vw;
  }

  & >>> {
    .md-field-item-content {
      height: 17.07vw;

      &:before {
        content: none;
      }
    }

    .md-field-item-title {
      width: 32vw;
      font-size: 3.73vw;
      font-weight: bold;
    }

    .md-field-item-control {
      width: 53.6vw;
      text-align: right;
    }

    .md-input-item-input {
      border: 0.27vw solid #eaf1f3;
      border-radius: 2.67vw;
      padding: 0 2.67vw;
      background: #f8fbfc;
    }

    .md-field-item-children {
      top: 100%;
      z-index: 10;
      margin-top: 0;
    }
  }

  .upload {
    & >>> {
      .md-field-item-content {
        height: auto;
        align-items: flex-start;
      }

      .md-field-item-title {
        margin-top: 5.33vw;
        width: 40vw;
      }

      .md-field-item-control {
        width: 40vw;
        flex: 0 0 auto;
      }
    }

    .upload-content {
      position: relative;
      box-sizing: border-box;
      margin-top: 2.67vw;
      border: 0.27vw solid #eaf1f3;
      border-radius: 2.67vw;
      height: 40vw;
      background: #f8fbfc;
      color: #BCC7CB;
      overflow: hidden;

      .preview-img {
        width: 100%;
        line-height: 40vw;
        vertical-align: middle;
      }

      .icon {
        width: 14vw;
        height: 14vw;
      }
    }
  }

  .info {
    margin-top: 4.8vw;
    color: #84969c;
  }

  .btn-wrapper {
    margin-top: 9.6vw;

    .md-button {
      margin-bottom: 4.8vw;
    }

    & >>> .md-activity-indicator-svg {
      width: 16vw !important;
      height: 4vw !important;
    }
  }
}

.image-reader-list
  float left
  width 100%
  padding-left 0
  .image-reader-item
    position relative
    float left
    width 23.5%
    padding-bottom 23.5%
    margin-bottom 2%
    margin-right 2%
    background #FFF
    box-shadow 0 5px 20px rgba(197, 202, 213, .25)
    box-sizing border-box
    list-style none
    border-radius 4px
    background-size cover
    &:nth-of-type(4n)
      margin-right 0
    &.add
      .md-icon
        position absolute
        top 40%
        left 50%
        transform translate(-50%, -50%)
        opacity .5
      p
        position absolute
        top 50%
        left 0
        width 100%
        margin-top 15px
        font-size 22px
        color #CCC
        text-align center
    .image-reader-item-del
      position absolute
      top 0
      right 0
      z-index 3
      opacity .8
      .md-icon-close
        font-size 24px
</style>
